export const COURSE_ACCESSES_RECEIVED = "COURSE_ACCESSES_RECEIVED";
export const SET_COURSE_ACCESS = "SET_COURSE_ACCESS";
